import { makeAutoObservable } from "mobx"

class BenefitStore {
  cardId = null
  detailedMode = false
  modalMode = false
  addBenefitModal = false

  constructor() {
    makeAutoObservable(this)
  }

  setCardId = (data) => (this.cardId = data)
  setDetailedMode = (data) => (this.detailedMode = data)
  setModalMode = (data) => (this.modalMode = data)
  setAddBenefitModal = (data) => (this.addBenefitModal = data)
}

export default new BenefitStore()
